import { render, staticRenderFns } from "./CotizacionesFormComponent.vue?vue&type=template&id=77e576d2&"
import script from "./CotizacionesFormComponent.vue?vue&type=script&lang=js&"
export * from "./CotizacionesFormComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports